module.exports = "\n<div class=\"comp-form-input\" :class=\"[hasError ? 'comp-form-input-error' : '']\">\n  <label v-if=\"hasLabel\" :for=\"id\"><em class=\"required\" v-if=\"isRequired\">*</em>{{ label }}</label>\n  <textarea :name=\"id\" :id=\"id\" :value=\"value\" v-on:input=\"updateValue($event.target.value)\" ref=\"input\" :rows=\"rows\"></textarea>\n  <div class=\"error\" v-if=\"hasError\">{{ error }}</div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./assets/js/frontend/components/form/textarea/index.pug
// module id = 695
// module chunks = 4